export enum OfferProductStatus {
  Pending = 1,
  Confirmed = 2,
  Rejected = 3,
  Removed = 4
}

(OfferProductStatus as any).__typeName = 'OfferProductStatus';
